import { createAsyncThunk } from '@reduxjs/toolkit'
import type { AxiosError } from 'axios'

import { ValidationErrors } from 'store/types'
import { getAxiosInstance } from 'services/api'
import { BecomeNode } from 'types/app'

const api = getAxiosInstance()

export const requestToBecomeNode = createAsyncThunk<
  BecomeNode,
  string, // Wallet address is passed as a string
  { rejectValue: ValidationErrors }
>(
  'becomenode/requestToBecomeNode',
  async (walletAddress, { rejectWithValue }) => {
    try {
      const { data } = await api.post('/node-operator/request', {
        walletAddress,
      })
      return data
    } catch (err) {
      const error = err as AxiosError<ValidationErrors>

      if (!error.response) {
        throw err
      }

      return rejectWithValue(error.response.data)
    }
  },
)

export const getNodePosition = createAsyncThunk<
  any,
  void,
  { rejectValue: ValidationErrors }
>('becomenode/getNodePosition', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/node-operator/position')
    return data
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>

    if (!error.response) {
      throw err
    }

    return rejectWithValue(error.response.data)
  }
})

export const leaveNodeOperatorQueue = createAsyncThunk<
  any,
  void,
  { rejectValue: ValidationErrors }
>('becomenode/leaveNodeOperatorQueue', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.delete('/node-operator/leave')
    return data
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>

    if (!error.response) {
      throw err
    }

    return rejectWithValue(error.response.data)
  }
})

// router.post("/set-registration-window", setRegistrationWindow);

export const setRegistrationWindow = createAsyncThunk<
  any,
  { startDate: string; endDate: string },
  { rejectValue: ValidationErrors }
>(
  'becomenode/setRegistrationWindow',
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const { data } = await api.post('/set-registration-window', {
        startDate,
        endDate,
      })
      return data
    } catch (err) {
      const error = err as AxiosError<ValidationErrors>

      if (!error.response) {
        throw err
      }

      return rejectWithValue(error.response.data)
    }
  },
)
// router.get("/get-registration-window-status", getRegistrationWindowStatus);

export const getRegistrationWindowStatus = createAsyncThunk<
  {
    isOpen: boolean
    startDate: string
    endDate: string
    currentTime: string
  },
  void,
  { rejectValue: ValidationErrors }
>('becomenode/getRegistrationWindowStatus', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/get-registration-window-status')
    return data
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>

    if (!error.response) {
      throw err
    }

    return rejectWithValue(error.response.data)
  }
})

// router.post("/stop-registration-window", stopRegistrationWindow);
export const stopRegistrationWindow = createAsyncThunk<
  any,
  void,
  { rejectValue: ValidationErrors }
>('becomenode/stopRegistrationWindow', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/stop-registration-window')
    return data
  } catch (err) {
    const error = err as AxiosError<ValidationErrors>

    if (!error.response) {
      throw err
    }

    return rejectWithValue(error.response.data)
  }
})
